import { FormControl, FormLabel, Input, Text, TextProps } from "@chakra-ui/react";
import { Controller } from "react-hook-form";

interface InputProps {
  name: string;
  control: any;
  errors?: any;
  label: string;
  type?: string;
  placeholder?: string;
  isRequired?: boolean;
  min?: string;
  max?: string;
  maxLength?: number;
  disable?: boolean;
  readOnly?: boolean;
  textTransform?: TextProps["textTransform"];
}

export const HrlenseInput = ({
  name,
  control,
  errors,
  label,
  type = "text",
  placeholder,
  isRequired = false,
  min,
  max,
  maxLength,
  disable,
  readOnly,
  textTransform
}: InputProps) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <FormControl isRequired={isRequired} isInvalid={!!errors?.[name]}>
          <FormLabel>
            {label}
          </FormLabel>
          <Input textTransform={textTransform} {...field} type={type} placeholder={placeholder} min={min} max={max} maxLength={maxLength} disabled={disable} readOnly={readOnly} />
          {errors?.[name] && (
            <Text color="red.500">{errors[name].message}</Text>
          )}
        </FormControl>
      )}
    />
  );
};

